import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HeroComponent } from "./hero.component";
import { LinebreaksModule } from "src/app/pipes/linebreaks/linebreaks.module";
import { BackgroundImageModule } from "src/app/directives/background-image/background-image.module";
import { TranslationModule } from "src/app/pipes/translation/translation.module";

@NgModule({
  declarations: [HeroComponent],
  imports: [CommonModule, TranslationModule, LinebreaksModule, BackgroundImageModule],
  exports: [HeroComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeroModule { }
